<template>
  <div>
    <v-card class="mx-auto" style="width: 90%" tile flat>
      <v-card-text class="primary--text text-center">
        Per completare la tua scelta inserisci il tuo nome, cognome ed un'email valida.
      </v-card-text>

      <v-card-text>
        <v-form ref="leadForm" lazy v-model="newLeadForm.valid">
          <v-form-base
            :row="{align:'center', justify:'center', noGutters:false}"
            v-bind:value="newLeadForm.data"
            v-bind:schema="newLeadSchema"
          />
          <v-checkbox
            v-model="newLeadForm.data.privacy_selected"
            :rules="[
              (v) =>
                !!v || 'Devi accettare termini e condizioni per continuare',
            ]"
            required
          >
            <template v-slot:label>
              <div>
                Accetto termini e condizioni
                del servizio.
              </div>
            </template>
          </v-checkbox>
          <!-- <div ><a :href="rulesUrl" color="primary">Scarica il regolamento</a></div> -->
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center" style="background-color: white">
        <v-btn color="primary darken-1" @click="sendLeadData()"
          >Invia</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="termsDialog" scrollable max-width="340px">
      <terms-and-conditions />
    </v-dialog>
  </div>
</template>

<script>
import VFormBase from 'vuetify-form-base'
import termsAndConditions from '@/components/qrcode-vote-components/ComponentTermsAndConditions'
import apiService from '@/services'

// Form rules
const formRules = {
  required: (field) => (v) =>
    (v != null && !!v && v.length > 0) || `${field} è obbligatorio`,
  requiredSelect: (field) => (v) => v || `${field} è obbligatorio`,
  validEmail: (v) => /.+@.+\..+/.test(v) || 'Inserire un e-mail valida'
}

export default {
  components: {
    VFormBase,
    termsAndConditions
  },
  computed: {
    newLeadSchema () {
      return {
        first_name: {
          type: 'text',
          label: 'Nome',
          col: 6,
          rules: [formRules.required('Nome')]
        },
        last_name: {
          type: 'text',
          label: 'Cognome',
          col: 6,
          rules: [formRules.required('Cognome')]
        },
        email: {
          type: 'text',
          label: 'Email',
          col: 12,
          rules: [
            formRules.required('Email'),
            (v) => /.+@.+\..+/.test(v) || 'Inserire un\'email valida'
          ]
        }
      }
    }
  },
  mounted () {
    // this.getCampaignRulesUrl()
  },
  data () {
    return {
      rowAttribute: {
        justify: 'center',
        align: 'center'
      },
      rulesUrl: '',
      newLeadForm: {
        data: {
          first_name: null,
          privacy_selected: false
        },
        valid: true
      },
      termsDialog: false,
      dataLoading: true,
      npo: {
        data: [],
        total: 0
      }
    }
  },

  methods: {
    sendLeadData () {
      if (this.$refs.leadForm.validate()) {
        const data = this.newLeadForm.data
        const campaign = JSON.parse(sessionStorage.getItem('campaign'))
        const qrcodeToken = sessionStorage.getItem('qrcodeToken')
        data.merchant_id = campaign.merchant_id
        data.campaign_id = campaign.campaign_id
        data.qrcode_token = qrcodeToken

        this.$emit('lead-vote', data)
      }
    },

    goBack () {
      this.$router.go(-1)
    },

    // Get Campaign rules download link
    getCampaignRulesUrl () {
      const campaign = JSON.parse(sessionStorage.getItem('campaign'))
      apiService
        .getCampaignRules(campaign.campaign_id)
        .then((response) => {
          this.rulesUrl = response
        })
        .catch(error => {
          if (error.response.status === 404) {
            return
          }
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error.message
          })
        })
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
.v-navigation-drawer {
  transition: none !important;
}

.v-content {
  background-color: #fff;
}

.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  );
}
</style>
